import { render } from "./electronic.vue?vue&type=template&id=44cff96a&scoped=true"
import script from "./electronic.vue?vue&type=script&lang=js"
export * from "./electronic.vue?vue&type=script&lang=js"

import "./electronic.vue?vue&type=style&index=0&id=44cff96a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44cff96a"]])

export default __exports__